var _defs, _path, _path2, _path3, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarthLoads(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.1 26.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EN 1997") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-938,66.84a0.85,0.85,0,0,0,0,1.2,0.85,0.85,0,0,0,1.2,0,6.15,6.15,0,0,1,4.27-1.42A6.15,6.15,0,0,1-928.23,68a0.84,0.84,0,0,0,.6.25A0.84,0.84,0,0,0-927,68a0.85,0.85,0,0,0,0-1.2,7.84,7.84,0,0,0-5.46-1.91A7.84,7.84,0,0,0-938,66.84Z",
    transform: "translate(954.05 -56.03)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-924.56,65.22A0.84,0.84,0,0,0-924,65a0.85,0.85,0,0,0,0-1.2,12.05,12.05,0,0,0-8.53-3.19A12.06,12.06,0,0,0-941,63.77a0.85,0.85,0,0,0,0,1.2,0.85,0.85,0,0,0,1.2,0,10.37,10.37,0,0,1,7.34-2.69A10.37,10.37,0,0,1-925.16,65,0.84,0.84,0,0,0-924.56,65.22Z",
    transform: "translate(954.05 -56.03)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-921.34,62a0.84,0.84,0,0,0,.6-0.25,0.85,0.85,0,0,0,0-1.2A16.63,16.63,0,0,0-932.5,56a16.63,16.63,0,0,0-11.76,4.52,0.85,0.85,0,0,0,0,1.2,0.85,0.85,0,0,0,1.2,0,14.93,14.93,0,0,1,10.56-4,14.93,14.93,0,0,1,10.56,4A0.84,0.84,0,0,0-921.34,62Z",
    transform: "translate(954.05 -56.03)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    y: 18.65,
    width: 43.1,
    height: 7.82,
    rx: 1.9,
    ry: 1.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthLoads);
export default __webpack_public_path__ + "static/media/Earth Loads.72440736.svg";
export { ForwardRef as ReactComponent };